export const routes = {
  home: '/',
  quiz: '/quiz',
  newPlanPaywall: '/new-plan-paywall',
};
